import React, { Component } from 'react';
import IconInput from '../../components/icon-input';
import IconAutocomplete from '../../components/icon-autocomplete';
import { Link, withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Recaptcha from 'react-recaptcha';
import Fetch from '../../common/fetch';
import './styles.css'





class SignUp extends Component {
  constructor(props) {
    super(props);
    this.fetch = new Fetch();
    this.state = {
      signingUp: true,
      isVerified: false,
      isLoaded: false
    };

    // these 2 variables is required by reCaptcha functionality 
    this.onloadCallback = this.onloadCallback.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  // this function gets all the address from RDS database sites table 
  async getSiteList() {
    const url = 'https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/site/list';
    const options = {
      method: 'GET'
    };

    return await this.fetch.request(url, options);
  }

  async componentDidMount() {
    // put all addresses in the siteList
    const siteList = await this.getSiteList();
    const addresses = siteList.reduce((acc, cur) => {
      acc.push(cur.address);
      return acc;
    }, []);
    this.setState({ isLoaded: true, siteList: addresses });
  }

  async signUp() {
    // AWS Cognito integration here
    event.preventDefault();
    const { email, password, givenName, familyName, address, city, state, zip, tenantowner } = this.state;

    // if this sign up form is invalid
    if (!this.isSignUpFormValid()) {
      return;
    }

    // this verfies if user clicked on the reCaptcha or not
    if (this.state.isVerified) {

      try {
        await Auth.signUp({
          username: email,
          password: password,
          attributes: {
            given_name: givenName,
            family_name: familyName,
            'custom:address1': address,
            'custom:city': city,
            'custom:state': state,
            'custom:zip': zip,
            'custom:tenantowner': tenantowner
          }
        });
        // redirect to welcome page
        this.props.history.push('/welcome');
      } catch (e) {
        console.log(e);
        alert(e.message);
      }

    } else {
      alert('Please Verify That You Are A Human');
    }
  } // signUp

  // make sure inputs are valid
  isSignUpFormValid() {
    const { email, password, passwordConfirmation, givenName, familyName, address, city, state, zip, tenantowner } = this.state;
    const passwordRequirements = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    const nonNumber = RegExp('[^0-9]');
    if (!email || !password || !passwordConfirmation || !givenName || !familyName || !address || !city || !state || !zip || !tenantowner) {
      alert('Missing Fields: Please Fill Out All Missing Fields');
      return false;
    }

    let lastAtPos = email.lastIndexOf('@');
    let lastDotPos = email.lastIndexOf('.');
    if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') === -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
      alert("Input Error: Please Input Valid Email Address ");
      return false;
    }
    if (password !== passwordConfirmation) {
      alert('Missmatched Password: Please Make Sure Your Password Matches');
      return false;
    }
    if (!passwordRequirements.test(password)) {
      alert('Missing Requirements: Password Must Be At Least 8 Characters And Contain At Least 1 Lowercase, 1 Uppercase, 1 Number, And 1 Special Character');
      return false;
    }
    if (nonNumber.test(zip)) {
      alert('Input Error: Please Input Zip Without Special Characters');
      return false;
    }
    if (tenantowner !== 'tenant' && tenantowner !== 'owner') {
      alert('Input Error: Please Input "Tenant" or "Owner"');
      return false;
    }
    return true;
  } // isSignUpFormValid

  onloadCallback() {
    // console.log('captcha successfully loaded');
  }

  verifyCallback(response) {
    if (response) {
      this.setState({
        // set to true if user checks reCaptcha
        isVerified: true
      })
    } else {
      console.log('Coud not get recaptcha response');
    }
  }


  render() {
    return (
      <div className='background-image ' style={{ 'paddingTop': '74px', 'paddingBottom': '40%' }}>
        <div className='d-flex h-100 justify-content-center '>
          <div className='align-self-md-center h-auto w-40 p-4 form-container '>
            <p className='signup-title'>CREATE YOUR ENERGIZE ACCOUNT</p>
            <IconInput icon='fa fa-envelope' placeholder='EMAIL' type='email' value={this.state.email} onChange={(input) => this.setState({ email: input.toLowerCase() })} />
            <IconInput icon='fa fa-lock' placeholder='PASSWORD' type='password' value={this.state.password} onChange={(input) => this.setState({ password: input })} />
            <IconInput icon='fa fa-lock' placeholder='CONFIRM YOUR PASSWORD' type='password' value={this.state.passwordConfirmation} onChange={(input) => this.setState({ passwordConfirmation: input })} />
            <IconInput icon='fa fa-user' placeholder='FIRST NAME' type='text' value={this.state.givenName} onChange={(input) => this.setState({ givenName: input })} />
            <IconInput icon='fa fa-user' placeholder='LAST NAME' type='text' value={this.state.familyName} onChange={(input) => this.setState({ familyName: input })} />
            {/* auto complete address input box, user can select an address from the address dropdown list */}
            <IconAutocomplete icon='fa fa-address-card' placeholder='ADDRESS' type='text' value={this.state.address} items={this.state.siteList} onChange={(input) => this.setState({ address: input })} />

            <IconInput icon='fa fa-address-card' placeholder='CITY' type='text' value={this.state.city} onChange={(input) => this.setState({ city: input })} />
            <IconInput icon='fa fa-address-card' placeholder='STATE' type='text' value={this.state.state} onChange={(input) => this.setState({ state: input })} />
            <IconInput icon='fa fa-address-card' placeholder='ZIP' type='number' value={this.state.zip} onChange={(input) => this.setState({ zip: input })} />
            <IconInput icon='fa fa-home' placeholder='TENANT OR OWNER' type='text' value={this.state.tenantowner} onChange={(input) => this.setState({ tenantowner: input.toLowerCase() })} />
            {/* reCaptcha functionality */}
            <div>
              <Recaptcha
                sitekey="6LdDVM0UAAAAAMy-91Kwmoql_pjpSSqkzP7DTcO6"
                render="explicit"
                verifyCallback={(response) => this.verifyCallback(response)}
                onloadCallback={this.onloadCallback}
              />
            </div>

            <div>
              <button
                type='button'
                className='btn btn-info btn-block font-weight-bold'
                onClick={() => this.signUp()}
              >
                SUBMIT
          </button>
            </div>
            {/* go back to login page */}
            <Link to='/login' className=' btn btn-link btn-block font-weight-bold link'>CANCEL (RETURN TO LOGIN)</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignUp);



// WEBPACK FOOTER //
// ./src/routes/signup/index.js